export default "__VITE_ASSET__DPIMYSCu__"